module.exports = __webpack_public_path__ + "static/media/img_noble.3382e434.jpg";